/* ============================================
   BAKACARTEL THEME - JavaScript
   ============================================ */

(function() {
  'use strict';

  // ---- Toast ----
  function showToast(msg) {
    const t = document.getElementById('bc-toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('show');
    setTimeout(() => t.classList.remove('show'), 2500);
  }
  window.BakaCartel = window.BakaCartel || {};
  window.BakaCartel.showToast = showToast;

  // ---- Drawer ----
  const drawerToggleBtns = document.querySelectorAll('[data-drawer-toggle]');
  const drawerOverlay = document.getElementById('drawer-overlay');
  const drawer = document.getElementById('bc-drawer');

  function openDrawer() {
    drawer && drawer.classList.add('open');
    drawerOverlay && drawerOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    drawer && drawer.classList.remove('open');
    drawerOverlay && drawerOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  drawerToggleBtns.forEach(btn => btn.addEventListener('click', openDrawer));
  drawerOverlay && drawerOverlay.addEventListener('click', closeDrawer);
  document.querySelectorAll('[data-drawer-close]').forEach(btn => btn.addEventListener('click', closeDrawer));

  // ---- Cart Count ----
  function updateCartCount() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const count = cart.item_count;
        document.querySelectorAll('.cart-count').forEach(el => {
          el.textContent = count;
          el.classList.toggle('visible', count > 0);
        });
      })
      .catch(() => {});
  }
  updateCartCount();

  // ---- Add To Cart ----
  document.querySelectorAll('[data-add-to-cart]').forEach(btn => {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      const variantId = this.dataset.variantId;
      if (!variantId) return;
      const originalHTML = this.innerHTML;
      this.innerHTML = '<span class="material-symbols-outlined" style="animation:spin 0.6s linear infinite">progress_activity</span>';
      this.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(r => r.json())
      .then(() => {
        updateCartCount();
        showToast('Added to cart!');
        this.innerHTML = '<span class="material-symbols-outlined">check</span>';
        setTimeout(() => { this.innerHTML = originalHTML; this.disabled = false; }, 1500);
      })
      .catch(() => {
        showToast('Something went wrong');
        this.innerHTML = originalHTML;
        this.disabled = false;
      });
    });
  });

  // ---- Cart Page: Qty & Remove ----
  document.querySelectorAll('[data-cart-qty]').forEach(btn => {
    btn.addEventListener('click', function() {
      const key = this.dataset.key;
      const delta = parseInt(this.dataset.delta);
      const currentQty = parseInt(this.closest('[data-cart-item]').querySelector('.qty-num').textContent);
      const newQty = Math.max(0, currentQty + delta);

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: newQty })
      })
      .then(r => r.json())
      .then(() => location.reload())
      .catch(() => {});
    });
  });

  // ---- Product Detail: Image Gallery ----
  const thumbs = document.querySelectorAll('.product-detail__thumb');
  const mainImg = document.querySelector('.product-detail__main-img img');

  thumbs.forEach(thumb => {
    thumb.addEventListener('click', function() {
      thumbs.forEach(t => t.classList.remove('active'));
      this.classList.add('active');
      if (mainImg) {
        const src = this.dataset.src;
        const srcset = this.dataset.srcset;
        mainImg.src = src;
        if (srcset) mainImg.srcset = srcset;
        mainImg.style.opacity = '0';
        setTimeout(() => { mainImg.style.opacity = '1'; }, 50);
        mainImg.style.transition = 'opacity 0.2s ease';
      }
    });
  });

  // ---- Reviews ----
  // Handled by Judge.me app — no custom JS needed.
  // Judge.me auto-initialises via its own script injected by Shopify.
  function showError(el, msg) {
    if (!el) return;
    el.textContent = msg;
    el.classList.add('visible');
    setTimeout(() => el.classList.remove('visible'), 3000);
  }

  function escapeHtml(str) {
    return str.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  // ---- Promo Code ----
  const promoForm = document.getElementById('promo-form');
  promoForm && promoForm.addEventListener('submit', function(e) {
    e.preventDefault();
    const code = document.getElementById('promo-code-input').value.trim();
    // Redirect to cart with discount applied
    if (code) window.location.href = `/discount/${code}?redirect=/cart`;
  });

  // ---- Animate on scroll ----
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    document.querySelectorAll('.product-card, .series-card, .review-card').forEach(el => {
      el.style.opacity = '0';
      el.style.transform = 'translateY(16px)';
      el.style.transition = 'opacity 0.4s ease, transform 0.4s ease';
      observer.observe(el);
    });
  }

})();

// Spin animation
const style = document.createElement('style');
style.textContent = '@keyframes spin { to { transform: rotate(360deg); } }';
document.head.appendChild(style);
